/**
 * Transcription credits: 1 credit per started minute of audio, minimum 1 (docs/SPEC.md §10.1).
 * The per-minute rate is an admin setting (`transcription.secondsPerCredit`); this is the pure maths.
 */
export function creditsForSeconds(seconds: number | null | undefined, secondsPerCredit = 60): number {
  if (typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds <= 0) return 1;
  return Math.max(1, Math.ceil(seconds / secondsPerCredit));
}
